import React from "react";
import {useNavigate} from "react-router-dom";
import {SxProps, Theme} from "@mui/material";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Icon from "shared/ui/Icon";
import CustomButton from "shared/ui/CustomButton";

interface AuthCardProps {
    image: string;
    title: string;
    description?: string;
    footer?: string;
    showBackButton?: boolean;
    onActionClick?: () => void;
    actionLabel?: string;
    children?: React.ReactNode;
    size: "medium" | "large";
}

const mediumCardStyles: SxProps<Theme> = (theme) => ({
    backdropFilter: "blur(10px)",
    padding: { xs: theme.spacing(5, 2), md: theme.spacing(5, 3) },
    borderRadius: { xs: 2, md: 3 },
    margin: { xs: 2, md: 0 },
    textAlign: "center",
    height: "100%",
    maxWidth: theme.breakpoints.values.xl,
});

const largeCardStyles: SxProps<Theme> = (theme) => ({
    backdropFilter: "blur(10px)",
    padding: {xs: theme.spacing(5, 2), md: theme.spacing(2, 3, 5, 3)},
    borderRadius: {xs: 2, md: 3},
    margin: {xs: 2, md: 0},
    maxWidth: theme.breakpoints.values.xl,
});

const AuthCardLayout = ({
                            image,
                            title,
                            description,
                            footer,
                            showBackButton = false,
                            onActionClick,
                            actionLabel = "Autentificare",
                            children,
                            size = "medium"
                        }: AuthCardProps) => {
    const navigate = useNavigate();

    return (
        <Grid item xs={12} sm={10} md={size === "medium"  ? 6 : 8} lg={size === "medium"  ? 5 : 6} xl={size === "medium"  ? 4 : 6}>
            <Box bgcolor="extra.sidebar_login" sx={size === "medium" ? mediumCardStyles : largeCardStyles}>
                {showBackButton && (
                    <IconButton sx={{color: "error.main"}} onClick={() => navigate("/")}>
                        <Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="center">
                            <Icon icon="far arrow-left-long" fixedWidth={true}/>
                        </Box>
                    </IconButton>
                )}

                <Box textAlign="center">
                    <img src={image} height="200px" style={{width: "auto"}} alt="Brio Platforma de Testare Fundamentata Stiintific"/>
                    <Typography variant="h1" mb={3} sx={{color: "primary.main", fontWeight: "bold"}}>
                        {title}
                    </Typography>
                </Box>

                {description && (
                    <Typography variant="body1" mb={3} fontWeight="bold">
                        {description}
                    </Typography>
                )}

                {onActionClick && (
                    <CustomButton
                        buttonType="textIconOutlined"
                        onClick={onActionClick}
                        color="info.contrastText"
                        borderColor="info.contrastText"
                        bgcolor="modal"
                        sxExtra={{borderRadius: 1}}
                    >
                        {actionLabel}
                    </CustomButton>
                )}

                {children}

                {footer && (
                    <Typography variant="body2" mt={2}>
                        {footer}
                    </Typography>
                )}
            </Box>
        </Grid>
    );
};

export default AuthCardLayout;